module.exports = __webpack_public_path__ + "static/media/Arndt.7b1bc4ec.jpg";